import api from './MentalApi';

const eventTypes = {
    notifyHistoryChanged: 'notifyHistoryChanged',
    updateUser: 'updateUser',
};


class RNIntegration {
    static notifyUserUpdate() {
        if (!RNIntegration.shouldPostMessages()) return;

        this.postMessage(eventTypes.updateUser, { user: api.getUserData() });
    }

    static notifiyHistoryChanged() {
        if (!RNIntegration.shouldPostMessages()) return;

        this.postMessage(eventTypes.notifyHistoryChanged, {});
    }

    private static shouldPostMessages(): boolean {
        // @ts-ignore
        return Boolean(window.ReactNativeWebView);
    }

    private static postMessage(type: string, data: any) {
        // @ts-ignore
        if (window.ReactNativeWebView) {
            // @ts-ignore
            window.ReactNativeWebView.postMessage(JSON.stringify({
                type,
                ...data,
            }));
        }
    }
}

export default RNIntegration;
